import { _, moment } from "../../../../../vendor";
import t from "../../../helpers/t";
import { rbac } from "../index";
import { Biscuit } from "../../../../utils";
import { in_array } from "../../../../utils/Helper";
import { insurancesActions, useSelector } from "inbooma-api";
//import * as OrderFunctions from "./behaviors/OrderFunctions";
import HelpMessageListItem from "./HelpMessageListItem";
import React, { useEffect, useState } from "react";
import { dateFormat, timeFormat } from "../../../../utils/FormatHelper";
import * as OrderFunctions from "../../reservations/components/behaviors/OrderFunctions";

const HelpMessageItem = (props) => {
  const { helpMessage, index, dispatch, currentUrl, deleteHelpMessage } = props;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const searchParams = currentUrl.searchParams;
  const [helpMessageLocal, setHelpMessageLocal] = useState(helpMessage);

  useEffect(() => {
    fillData();
  }, []);

  let helpMessagesData = null;
  const fillData = () => {
    helpMessagesData = null;
    let ins;
    let toggle = false;
    ins = helpMessageLocal;
    if (
      typeof searchParams.get("item") !== "undefined" &&
      searchParams.get("item") !== null &&
      Number(ins.id) === Number(searchParams.get("item"))
    ) {
      toggle = true;
    }

    let addClasses = "";
    if (toggle) {
      addClasses += " toggled";
    }
    let elements = [
      {
        type: "text",
        value: "screen",
        title: "",
        extraClasses: "inb-order-date",
        data: [
          {
            text: ins.screen,
            value: "screen",
            title: t("screen"),
          },
        ],
        mediumWidth: 1,
        smallWidth: 2,
      },
      {
        type: "text",
        value: "client_id",
        title: "",
        extraTopClasses: "",
        data: [
          {
            value: "client_id",
            text: ins.client_id,
            extraClasses: "",
            title: t("client_id", null, "capital"),
          },
        ],
        mediumWidth: 1,
        smallWidth: 2,
      },
    ];

    elements.push({
      type: "HelpMessageItemsAddition",
      value: "help_message_items",
      title: "",
      data: [
        {
          value: "help_message_items",
          text: "",
          title: "",
          certificates: ins.help_message_items,
          id: ins.id,
          insurance: ins,
          dispatch: dispatch,
        },
      ],
      mediumWidth: 12,
      smallWidth: 12,
    });

    if (elements !== []) {
      helpMessagesData = {
        elements: elements,
        addClasses: addClasses,
      };
    }
  };

  const getContextMenu = (help) => {
    let contextMenu = [
      {
        text: t("edit"),
        href: "/help_messages/" + helpMessage.id + currentUrl.search,
        iconClass: "fi fi-wrench",
        title: "edit",
      },
    ];

    contextMenu.push({
      text: t("delete"),
      href: "#",
      clickHandler: deleteHelpMessage,
      getItem: "helpMessage",
      helpMessage: helpMessage,
      iconClass: "fi fi-trash",
      title: "delete",
    });

    return contextMenu;
  };
  fillData();
  let helpMessageMenu = getContextMenu(helpMessage);

  return (
    <>
      {helpMessagesData !== null && (
        <HelpMessageListItem
          key={"wti-" + index}
          _key={"wti-" + index}
          listStyle="tight"
          id={"reservations-item-" + helpMessageLocal.id}
          overwriteClasses={
            "inb-c-item inb-c-item--order inb-c-item-contingents row" + helpMessagesData.addClasses
          }
          elements={helpMessagesData.elements}
          helpMessageId={helpMessageLocal?.id}
          helpMessage={helpMessageLocal}
          dispatch={dispatch}
          length={
            typeof helpMessageLocal?.help_message_items !== "undefined"
              ? helpMessageLocal?.help_message_items.length
              : 1
          }
          helpMessageItems={
            typeof helpMessageLocal?.help_message_items !== "undefined"
              ? helpMessageLocal?.help_message_items
              : []
          }
          menu={helpMessageMenu}
        />
      )}
    </>
  );
};
export default HelpMessageItem;
